<template>
  <v-list-item
    v-bind="$attrs"
    v-on="$listeners"
  >
    <v-list-item-icon
      v-if="$slots.icon"
      class="ma-0 mt-2 ml-3"
    >
      <v-icon>
        <slot name="icon"></slot>
      </v-icon>
    </v-list-item-icon>
    <v-list-item-content>
      <slot name="content"></slot>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
export default {
  name: "AppListItem",
};
</script>

<style></style>
